module.exports = __webpack_public_path__ + "media/87_BL.8e798445.mp3";